import "./index.css";
import "./global.css";
import React from "react";
import { Routes, Route } from "react-router-dom";
import { AuthProvider } from "./contexts/AuthContext";
import Home from "./pages/home";
import Projects from "./pages/projects";
import Terms from "./pages/terms";
import Privacy from "./pages/privacy";
import UserLayout from "./layouts/UserLayout";
import AdminLayout from "./admin";
import MainGrid from "./admin/components/MainGrid";
import AdminProjectPage from "./admin/project/page";
import Login from "./pages/admin/Login";
import ProtectedRoute from "./components/ProtectedRoute";
import AdminRequestPage from "./admin/requests/page";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Routes>
          <Route
            path="/"
            element={
              <UserLayout>
                <Home />
              </UserLayout>
            }
          />
          <Route
            path="/projects"
            element={
              <UserLayout>
                <Projects />
              </UserLayout>
            }
          />
          <Route
            path="/terms"
            element={
              <UserLayout>
                <Terms />
              </UserLayout>
            }
          />
          <Route
            path="/privacy"
            element={
              <UserLayout>
                <Privacy />
              </UserLayout>
            }
          />
          <Route
            path="/admin/login"
            element={<Login />}
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <MainGrid />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/projects"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminProjectPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin/requests"
            element={
              <ProtectedRoute>
                <AdminLayout>
                  <AdminRequestPage />
                </AdminLayout>
              </ProtectedRoute>
            }
          />
          {/*<Route*/}
          {/*  path="/about"*/}
          {/*  element={<About />}*/}
          {/*/>*/}
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;
